import React from 'react';
import { INTELLIMIZE_PRICESECTION_EVENT } from '../../../constants/defaults';
import _ from 'lodash';

const Paginator = ({ page, totalPages, onPrev, onNext, onGoTo }) => {
  const onPaginationClick = () => {
    _.sendIntellimizeEvent(INTELLIMIZE_PRICESECTION_EVENT.PAGINATION_CLICK);
  };

  return (
    <div className="price-section__footer">
      <div
        className="price-section__pagination"
        role="group"
        aria-label="Carousel pagination"
      >
        <button
          type="button"
          className="price-section__arrow"
          onClick={() => {
            onPaginationClick();
            onPrev();
          }}
          disabled={page === 0}
          aria-label="Previous price cards"
        >
          ‹
        </button>
        <div
          className="price-section__dots"
          role="tablist"
          aria-label="Carousel pages"
        >
          {Array.from({ length: totalPages }).map((_, i) => (
            <button
              key={i}
              type="button"
              role="tab"
              aria-selected={i === page}
              aria-label={`Show page ${i + 1} of ${totalPages}`}
              className={`price-section__dot ${i === page ? 'is-active' : ''}`}
              onClick={() => onGoTo(i)}
            />
          ))}
        </div>
        <button
          type="button"
          className="price-section__arrow"
          onClick={() => {
            onPaginationClick();
            onNext();
          }}
          disabled={page >= totalPages - 1}
          aria-label="Next price cards"
        >
          ›
        </button>
      </div>
    </div>
  );
};

export default Paginator;
